import { Injectable } from '@angular/core';
import { EnvironmentService } from './environment.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, catchError, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConsumptionService {

  envs: any = this.env.envVariables;
  baseUrl: string = `${this.envs.httpProtocol}${this.envs.webHost}Consumption`;

  constructor(private env: EnvironmentService, private http: HttpClient) { }

  getBillingData(ids: string, type: string, from: string, to: string, entity: string = "User"): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
    .set('Cache-Control', 'no-cache')
    .set('EntityIds', ids)
    .set('ConsumptionType', type)
    .set('FromDate', from)
    .set('ToDate', to)
    .set('Entity', entity)

    return this.http.get(`${this.baseUrl}/userData`, { headers }).pipe(
      catchError(error => {
        // You can handle the error here, log it, or perform any custom actions.
        console.error('An error occurred:', error);
        return of([]);
      })
    );
  }
}
